export default "__VITE_ASSET__BoM4aufr__"